import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button } from '@mui/material';
import TreeView, { flattenTree } from 'react-accessible-treeview';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

const folder = {
  name: '',
  id: 'treeview',
  children: [
    {
      id: 'limestone',
      name: 'calciumCarbonateBlocksGranules',
      children: [
        {
          name: 'grains',
          id: 'Limestone_Grains',
          children: [
            { name: 'RL-05', id: 'RL-05' },
            { name: 'RL-10', id: 'RL-10' },
            { name: 'RL-12', id: 'RL-12' },
            { name: 'RL-23', id: 'RL-23' },
            { name: 'RL-48', id: 'RL-48' },
          ],
        },
        {
          name: 'blocks',
          id: 'Limestone_Blocks',
          children: [
            { name: 'RM-01', id: 'RM-01' },
            { name: 'RM-12', id: 'RM-12' },
            { name: 'RM-35', id: 'RM-35' },
            { name: 'RM-58', id: 'RM-58' },
            { name: 'RM-85', id: 'RM-85' },
            { name: 'RM-100', id: 'RM-100' },
          ],
        },
      ],
    },
    {
      id: 'calciumCarbonate',
      name: 'calciumCarbonateCoatedUncoated',
      children: [
        {
          name: 'coated',
          id: 'calciumCarbonateCoated',
          children: [
            { name: 'RC-05T', id: 'RC-05T' },
            { name: 'RC-08T', id: 'RC-08T' },
            { name: 'RC-10T', id: 'RC-10T' },
            { name: 'RC-15T', id: 'RC-15T' },
            { name: 'RC-20T', id: 'RC-20T' },
            { name: 'RC-25T', id: 'RC-25T' },
          ],
        },
        {
          name: 'uncoated',
          id: 'calciumCarbonateUncoated',
          children: [
            { name: 'RC-05', id: 'RC-05' },
            { name: 'RC-08', id: 'RC-08' },
            { name: 'RC-10', id: 'RC-10' },
            { name: 'RC-15', id: 'RC-15' },
            { name: 'RC-20', id: 'RC-20' },
            { name: 'RC-25', id: 'RC-25' },
            { name: 'RC-30', id: 'RC-30' },
            { name: 'RC-40', id: 'RC-40' },
            { name: 'RC-50', id: 'RC-50' },
            { name: 'RC-80', id: 'RC-80' },
            { name: 'RC-100', id: 'RC-100' },
            { name: 'RC-150', id: 'RC-150' },
          ],
        },
      ],
    },

    {
      id: 'calcite',
      name: 'calcite',
      children: [
        {
          name: 'grainsBlocks',
          id: 'calciteGrains&blocks',
          children: [
            { name: 'RK-01', id: 'RK-01' },
            { name: 'RK-05', id: 'RK-05' },
            { name: 'RK-12', id: 'RK-12' },
            { name: 'RK-23', id: 'RK-23' },
            { name: 'RK-48', id: 'RK-48' },
            { name: 'RK-105', id: 'RK-105' },
            { name: 'RK-508', id: 'RK-508' },
          ],
        },
      ],
    },

    {
      id: 'calciumOxide',
      name: 'calciumOxide',
      children: [
        {
          name: 'powder',
          id: 'calciumOxidePowder',
          children: [
            { name: 'RO-70T', id: 'RO-70T' },
            { name: 'RO-80T', id: 'RO-80T' },
            { name: 'RO-90T', id: 'RO-90T' },
          ],
        },
        {
          name: 'blocks',
          id: 'calciumOxideBlocks',
          children: [
            { name: 'RO-70', id: 'RO-70' },
            { name: 'RO-80', id: 'RO-80' },
            { name: 'RO-90', id: 'RO-90' },
          ],
        },
      ],
    },
    {
      id: 'dolomite',
      name: 'dolomite',
      children: [
        {
          name: 'grainsBlocks',
          id: 'dolomiteGrains&blocks',
          children: [
            { name: 'RD-05', id: 'RD-05' },
            { name: 'RD-12', id: 'RD-12' },
            { name: 'RD-23', id: 'RD-23' },
            { name: 'RD-46', id: 'RD-46' },
            { name: 'RD-68', id: 'RD-68' },
          ],
        },
      ],
    },

    {
      id: 'calciumHydroxide',
      name: 'calciumHydroxide',
      children: [
        {
          name: 'powder',
          id: 'calciumHydroxidePowder',
          children: [
            { name: 'RH-70', id: 'RH-70' },
            { name: 'RH-80', id: 'RH-80' },
            { name: 'RH-90', id: 'RH-90' },
          ],
        },
      ],
    },
  ],
};

const ArrowIcon = ({ isOpen }) => {
  return <>{isOpen ? <KeyboardArrowDownIcon /> : <KeyboardArrowRightIcon />}</>;
};

const data = flattenTree(folder);

const ProductsTree = () => {
  const { t, i18n } = useTranslation();
  const [expandedIds, setExpandedIds] = useState([
    'limestone',
    'Limestone_Grains',
    'Limestone_Blocks',

    'calciumCarbonate',
    'calciumCarbonateCoated',
    'calciumCarbonateUncoated',

    'calciumHydroxide',
    'calciumHydroxidePowder',

    'calciumOxide',
    'calciumOxidePowder',
    'calciumOxideBlocks',

    'dolomite',
    'dolomiteGrains&blocks',

    'calcite',
    'calciteGrains&blocks',
  ]);
  const [hover, setHover] = useState(false);
  const [isOpenDialog, setIsOpenDialog] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);

  const navigate = useNavigate();

  const openDetails = (name, element) => {
    console.log(name, element);
    setSelectedProduct(element);
    setIsOpenDialog(true);
  };
  const handleClose = () => setIsOpenDialog(false);

  const loadProductImage = (fileName) => {
  try {
    return require(`../../assets/imgProducts/${fileName}.jpg`);
  } catch {
    return require('../../assets/imgProducts/placeholder.png');
  }
};

  return (
    <div style={{ marginTop: '50px', padding: '10px 20px' }}>
      <div className="basic">
        <TreeView
          style={{
            listStyle: 'none',
            margin: '0px',
            padding: '20px',
            display: 'flex',
            justifyContent: 'space-between',
          }}
          data={data}
          aria-label="Controlled expanded node tree"
          expandedIds={expandedIds}
          defaultExpandedIds={expandedIds}
          nodeRenderer={({
            element,
            isBranch,
            isExpanded,
            isDisabled,
            getNodeProps,
            level,
            handleExpand,
          }) => {
            // console.log({ element, isBranch, isExpanded, isDisabled, level });
            return (
              <div
                {...getNodeProps({ onClick: level > 1 && handleExpand })}
                style={{
                  //   marginLeft: 30 * (level - 1),
                  ...(i18n.language === "ar"
                  ? { marginRight: level > 2 ? "30px" : 0 }
                  : { marginLeft: level > 2 ? "30px" : 0 }),

                  opacity: isDisabled ? 0.5 : 1,
                  marginBottom: '20px',
                }}
              >
                {isBranch && level > 1 && <ArrowIcon isOpen={isExpanded} />}
                {}
                {isBranch && level > 1 ? (
                  <span
                    style={{
                      padding: '5px 8px',
                      borderRadius: '3px',
                      //   backgroundColor: 'beige',

                      backgroundColor: '#9a4a20',
                      color: 'white',
                    }}
                  >
                    {t(element.name)}
                  </span>
                ) : isBranch && level === 1 ? (
                  <span
                    style={{
                      backgroundColor: '#aa806a',
                      color: 'white',
                      padding: '5px 10px',
                      borderRadius: '5px',
                      minWidth: '165px',
                      maxWidth: i18n.language == 'ar' ?  '160px': '180px',
                      minHeight: '50px',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      textAlign: 'center'
                    }}
                  >
                    {t(element.name)}
                  </span>
                ) : (
                  <span
                    onClick={() => openDetails(element.name, element)}
                    className="hoverable-span"
                  >
                    {t(element.name)}
                  </span>

                  // <span
                  //   style={{
                  //     backgroundColor: hover ? "#ffcc80" : "blanchedalmond", // hover effect
                  //     padding: "3px 5px",
                  //     borderRadius: "3px",
                  //     cursor: "pointer",
                  //     transition: "background-color 0.2s ease",
                  //   }}
                  //   onMouseEnter={() => setHover(true)}
                  //   onMouseLeave={() => setHover(false)}
                  // >
                  //   {element.name}
                  // </span>
                )}
              </div>
            );
          }}
        />
      </div>

      {isOpenDialog && (
        <Dialog
          open={isOpenDialog}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          maxWidth={'lg'}
        >
          <DialogTitle
            id="alert-dialog-title"
            style={{ display: 'flex', justifyContent: 'space-between' }}
          >
            <div style={{ fontSize: '20px', fontWeight: 600 }}>
              <span>{selectedProduct?.parent?.split('_')[0]}</span>{' '}
              <span>( {selectedProduct?.parent?.split('_')[1]} )</span>
            </div>
            <div style={{ fontSize: '20px', fontWeight: 600 }}>
              Item code:{' '}
              <span style={{ color: 'red' }}>{selectedProduct.name}</span>
            </div>
          </DialogTitle>

          <DialogContent>
            <div style={{width: '100%', textAlign: 'center'}}>
                {/* <img style={{borderRadius: '5px', objectFit:'cover'}} src={require(`../../assets/imgProducts/${selectedProduct.name}.jpg`)} width={300} height={300}/> */}
                <img
                  style={{ borderRadius: '5px', objectFit: 'cover' }}
                  src={loadProductImage(selectedProduct.name)}
                  width={300}
                  height={300}
              />
            </div>

            <DialogContentText id="alert-dialog-description">
                <img style={{borderRadius: '5px', objectFit:'cover'}} src={require(`../../assets/imgProducts/${selectedProduct.name}-details.jpg`)} width={'100%'} height={'100%'}/>

            </DialogContentText>
            
          </DialogContent>

          <DialogActions>
            <Button onClick={handleClose}>Close</Button>
          </DialogActions>

        </Dialog>
      )}
    </div>
  );
};

export default ProductsTree;
